import React, { Component } from 'react';
import classnames from 'classnames';
import path from 'path-browserify';
import { TreeNode, TreeModelContext, TreeModel } from '../../atoms/tree-layer';
import { FileView } from './file-tree-nodes';

import styles from './file-explorer.module.scss';
import { Title } from './title';
import { IPromisesAPI } from 'memfs/lib/promises';
import { InnerNode, RootNode } from './file-tree-nodes';
import { HotKeys } from 'react-keyboard';

type FileExplorerProps = {
	fs?: IPromisesAPI;
	workDir: string;
	onFileSelected?: (filepath?: string) => any;
	selectedFile?: string;
};

type State = {
	refresh: number;
	treeModel?: TreeModel;
};

const keyBindings = { rename: 'enter', delete: ['del', 'backspace'] };

export class FileExplorer extends Component<FileExplorerProps, State> {
	state: State = {
		refresh: 0,
		treeModel: undefined,
	};

	constructor(props: FileExplorerProps) {
		super(props);

		if (props.fs) {
			const treeModel = this.makeModel(props.fs, props.workDir, props.selectedFile);
			this.state.treeModel = treeModel;
		}
	}

	componentWillReceiveProps(nextProps: FileExplorerProps) {
		const prevProps = this.props;

		if (prevProps.fs !== nextProps.fs && nextProps.fs) {
			const treeModel = this.makeModel(
				nextProps.fs,
				nextProps.workDir,
				nextProps.selectedFile
			);
			this.setState({ treeModel });
		}
	}

	makeModel = (fs: IPromisesAPI, workDir: string, selectedFile?: string) => {
		const treeModel = new TreeModel({ fs, workDir, selectedFile });

		treeModel._onFileSelected = this.props.onFileSelected;
		treeModel.onTreeChange = this.reload;
		return treeModel;
	};

	reload = () => {
		this.setState({ refresh: this.state.refresh + 1 });
	};

	private getNodeComponent = (node?: TreeNode<undefined>) => {
		if (!node) return () => null;
		if (node.children) {
			return InnerNode;
		}

		return FileView;
	};

	private validateNewFilename = (nextName: string) => {
		const { workDir } = this.props;
		const { treeModel } = this.state;
		if (!treeModel) return true;

		return (
			treeModel.isValidFilename(nextName) &&
			treeModel.canRename(path.join(workDir, nextName))
		);
	};

	render() {
		const { treeModel } = this.state;
		if (!treeModel) return <div className={styles.fileExplorer} />;

		const { fileTree } = treeModel;

		return (
			<TreeModelContext.Provider value={treeModel}>
				<HotKeys
					focusOnMount={false}
					keyMap={keyBindings}
					className={styles.keyBindings}
				>
					<div className={classnames(styles.fileExplorer, styles.running)}>
						<Title
							validateRename={this.validateNewFilename}
							onFileAdded={treeModel.writeFile}
							onFolderAdded={treeModel.mkdir}
							// onRefresh={treeModel.syncFromFs}
						>
							Files
						</Title>

						<RootNode
							className={styles.treeRoot}
							node={fileTree}
							getTreeNodeComponent={this.getNodeComponent}
						/>
					</div>
				</HotKeys>
			</TreeModelContext.Provider>
		);
	}
}
